const Container = ({ children }) => {
  return (
    <div className="bg-background bg-100% bg-no-repeat py-5 flex flex-1">
      <div className="container mx-auto ">{children}</div>
    </div>
  );
};

export default Container;
